import { PivotDateObject } from './types';

export const MIN_ALLOWED_AGE: number = 18;
export const MAX_ALLOWED_AGE: number = 85;

export function isAgeInProgramRange(dateObject: PivotDateObject): boolean {
  const userBirthday = dateFromDateObj(dateObject).getTime();
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  const maxAge = new Date(year - MAX_ALLOWED_AGE, month, day).getTime();
  const minAge = new Date(year - MIN_ALLOWED_AGE, month, day).getTime();
  return userBirthday - minAge <= 0 && userBirthday - maxAge >= 0;
}

export function isValidDate(dateObject: PivotDateObject): boolean {
  const userBirthday: Date = dateFromDateObj(dateObject);

  // Validation that checks for "carried over" dates like Feb 31st which translates to March 3rd
  return (
    userBirthday.getFullYear() === dateObject.year &&
    userBirthday.getMonth() === dateObject.month &&
    userBirthday.getDate() === dateObject.day
  );
}

export function dateFromDateObj(dateObject: PivotDateObject): Date {
  return new Date(dateObject.year, dateObject.month, dateObject.day);
}

export function formatDate(d: Date | unknown): string {
  if (d instanceof Date && !isNaN(d as unknown as number)) {
    const [yyyy, mm, dd] = d.toISOString().slice(0, 10).split('-');
    return `${mm}/${dd}/${yyyy}`;
  }
  return '';
}

export const MONTHS: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MAX_MONTHS_IN_JS_YEAR: number = 11;
export const MAX_DAYS_IN_MONTH: number = 31;
